import {Component, effect, input} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-headline-section',
  templateUrl: './headline-section.component.html',
  styleUrls: ['./headline-section.component.scss']
})
export class HeadlineSectionComponent {

  title = input<string>();
  badge = input<string>();
  loading = input<boolean>(false);

  constructor(private titleService: Title) {
    effect(() => {
      const title = this.title();
      if (title) {
        this.titleService.setTitle(`${title} - Content Platform`);
      }
    });
  }
}
